export const MAX_RETENTION_TIME = 60 * 24 * 7; // 7 days in minutes
